var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSb(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 512,
    width: 512,
    id: "flag-icon-css-sb",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M0 0h496.06v496.06H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    transform: "scale(1.0321)",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 491.39L956.69 0H0v491.39z",
    fill: "#0000d6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992.13 0L26.33 496.06h965.8V0z",
    fill: "#006000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992.163 0h-53.167L0 470.248v25.815h53.15L992.146 26.732V-.002z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M39.029 96.123l11.55-33.35-30.168-20.601 37.272.034L69.171 8.837l11.488 33.37 37.273-.025-30.175 20.592 11.546 33.354-30.137-20.641zm185.194 0l11.55-33.35-30.168-20.601 37.272.034 11.488-33.369 11.488 33.37 37.273-.025-30.175 20.592 11.546 33.354-30.137-20.641zm0 139.987l11.55-33.35-30.168-20.602 37.272.034 11.488-33.369 11.488 33.37 37.273-.025-30.175 20.592 11.546 33.354-30.137-20.641zm-92.054-69.176l11.55-33.35-30.168-20.601 37.272.034 11.488-33.369 11.488 33.37 37.273-.025-30.175 20.592 11.546 33.354-30.137-20.641zm-93.14 69.176l11.55-33.35-30.168-20.602 37.272.034 11.488-33.369 11.488 33.37 37.273-.025-30.175 20.592 11.546 33.354-30.137-20.641z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSb);
export default __webpack_public_path__ + "static/media/sb.194f33c88dd318b7289e7df3ec6ff7af.svg";
export { ForwardRef as ReactComponent };